import { ReactElement } from 'react'

import ApplicationPageAccess from 'lib/authorization/ApplicationPageAccess'
import { useAppSelector } from 'redux/Hook'

//Check if authorized based on feature toggle as well as role privileges
export const isAuthorized = (featureName: string) => {
  const featureToggles = useAppSelector((state) => state.features)
  const { roleName } = useAppSelector((state) => state.user.user)

  if (!featureToggles.doneFetching) return false

  const applicationPageAccess = ApplicationPageAccess(featureToggles.features)

  return applicationPageAccess.canView(featureName, roleName)
}

export const renderIfAllowed = (
  featureName: string,
  component: ReactElement,
) => {
  if (isAuthorized(featureName)) return component
}
